module.exports = __webpack_public_path__ + "media/images/logo-363e26df8c5dbfd2dabbcd4791056fcb.svg";